<main class="legal-page">
  <article class="legal-content">
    <h1>{{ titleKey | traduccion }}</h1>
    @if (content !== null) {
      <div class="legal-body" [innerHTML]="content"></div>
    } @else {
      <p>{{ 'legal.unavailable' | traduccion }}</p>
    }
  </article>
</main>
